import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-22f2c04f")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_InputText = _resolveComponent("InputText")!

  return (_openBlock(), _createBlock(_component_InputText, {
    type: "text",
    modelValue: _ctx.selected,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.selected = $event)),
    class: ["p-inputtext-sm p-mb-2", { 'is-error': _ctx.error }],
    placeholder: _ctx.placeholder
  }, null, 8, ["modelValue", "class", "placeholder"]))
})